var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAltonomy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 19,
    viewBox: "0 0 134 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_597_13266)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.690918 18.2645H46.5401V0.547852H0.690918V18.2645ZM30.7594 3.65639H43.3921V5.35199H38.1248V15.1361H36.1735V5.35199H30.7594V3.65639ZM21.4136 3.65639H23.3792V13.44H31.7565V15.1361H21.4136V3.65639ZM10.7469 3.65639H12.1703L18.9926 15.1361H16.7919L11.4664 5.8903L6.0523 15.1361H3.88074L10.7469 3.65639Z",
    fill: "#D2EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6423 6.41271C60.6423 5.70624 60.2114 5.35301 59.351 5.35301H52.5287C51.6678 5.35301 51.2378 5.70624 51.2378 6.41271V12.3809C51.2378 13.0874 51.6678 13.4406 52.5287 13.4406H59.351C60.2114 13.4406 60.6423 13.0874 60.6423 12.3809V6.41271ZM52.5287 15.1366C51.9417 15.1366 51.4429 15.069 51.0323 14.933C50.6213 14.7969 50.2862 14.6068 50.0271 14.3622C49.768 14.1175 49.5798 13.8268 49.4625 13.4896C49.3452 13.1529 49.2861 12.7777 49.2861 12.3644V6.42919C49.2861 6.01596 49.3452 5.64075 49.4625 5.304C49.5798 4.96724 49.768 4.67612 50.0271 4.43148C50.2862 4.18683 50.6213 3.99669 51.0323 3.86064C51.4429 3.72501 51.9417 3.65698 52.5287 3.65698H59.351C59.938 3.65698 60.4368 3.72501 60.8478 3.86064C61.2584 3.99669 61.5935 4.18683 61.853 4.43148C62.1117 4.67612 62.2999 4.96724 62.4176 5.304C62.5349 5.64075 62.594 6.01596 62.594 6.42919V12.3644C62.594 12.7777 62.5349 13.1529 62.4176 13.4896C62.2999 13.8268 62.1117 14.1175 61.853 14.3622C61.5935 14.6068 61.2584 14.7969 60.8478 14.933C60.4368 15.069 59.938 15.1366 59.351 15.1366H52.5287Z",
    fill: "#D2EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.615 15.1366L67.5968 6.20102V15.1366H65.8945V3.65698H67.5816L77.8672 12.1853V3.65698H79.5691V15.1366H78.615Z",
    fill: "#D2EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.2254 6.41271C94.2254 5.70624 93.7949 5.35301 92.9341 5.35301H86.1118C85.2509 5.35301 84.8209 5.70624 84.8209 6.41271V12.3809C84.8209 13.0874 85.2509 13.4406 86.1118 13.4406H92.9341C93.7949 13.4406 94.2254 13.0874 94.2254 12.3809V6.41271ZM86.1118 15.1366C85.5252 15.1366 85.0264 15.069 84.6158 14.933C84.2048 14.7969 83.8697 14.6068 83.6106 14.3622C83.3511 14.1175 83.1629 13.8268 83.0456 13.4896C82.9283 13.1529 82.8696 12.7777 82.8696 12.3644V6.42919C82.8696 6.01596 82.9283 5.64075 83.0456 5.304C83.1629 4.96724 83.3511 4.67612 83.6106 4.43148C83.8697 4.18683 84.2048 3.99669 84.6158 3.86064C85.0264 3.72501 85.5252 3.65698 86.1118 3.65698H92.9341C93.5211 3.65698 94.0203 3.72501 94.4309 3.86064C94.8419 3.99669 95.1765 4.18683 95.4361 4.43148C95.6947 4.67612 95.8834 4.96724 96.0007 5.304C96.118 5.64075 96.1771 6.01596 96.1771 6.42919V12.3644C96.1771 12.7777 96.118 13.1529 96.0007 13.4896C95.8834 13.8268 95.6947 14.1175 95.4361 14.3622C95.1765 14.6068 94.8419 14.7969 94.4309 14.933C94.0203 15.069 93.5211 15.1366 92.9341 15.1366H86.1118Z",
    fill: "#D2EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.402 15.1366V7.09763L108.149 15.1366H106.55L101.282 7.11411V15.1366H99.478V3.65698H101.297L107.43 13.0329L113.533 3.65698H115.206V15.1366H113.402Z",
    fill: "#D2EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.258 15.1366V10.4728L117.626 3.65698H120.12L125.226 8.90774L130.333 3.65698H132.797L126.209 10.4728V15.1366H124.258Z",
    fill: "#D2EAFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_597_13266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132.505,
    height: 17.7462,
    fill: "white",
    transform: "translate(0.688965 0.548828)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltonomy);
export default __webpack_public_path__ + "static/media/altonomy.a157070bbd3dc18dd9bbcc2718cab27d.svg";
export { ForwardRef as ReactComponent };